module.exports = __webpack_public_path__ + "static/media/22.4b89cb67.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/22.png
// module id = 389
// module chunks = 0